import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';

const schema = yup.object().shape({
    name: yup.string('نام باید حروف باشد').required("نام الزامیست"),
    family: yup.string("نام خانوادگی باید حروف باشد").required("نام خانوادگی الزامیست"),
    // age: yup.required("سن الزامیست").positive("سن باید اعداد مثبت باشد").integer("سن باید عدد صحیح باشد"),
    age: yup.number()
        .typeError("سن باید عدد باشد")
        .required("وارد کردن سن الزامی است")
        .min(18, "حداقل سن باید ۱۸ سال باشد")
        .max(100, "حداکثر سن می‌تواند ۱۰۰ سال باشد"),
    email: yup.string("ایمیل باید حروف باشد").required("ایمیل الزامیست").email("پست الکترونیکی باید ایمیل باشد"),
    // password: yup.string().required(),
    // confirmPassword: yup.string().required(),
    password: yup.string("رمز عبور باید حروف باشد")
        .required('رمز عبور الزامی است')
        .min(8, 'رمز عبور باید حداقل ۸ کاراکتر باشد')
        .matches(/[A-Z]/, 'باید حداقل یک حرف بزرگ داشته باشد')
        .matches(/[a-z]/, 'باید حداقل یک حرف کوچک داشته باشد')
        .matches(/[0-9]/, 'باید حداقل یک عدد داشته باشد')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'باید حداقل یک کاراکتر خاص داشته باشد'),
    confirmPassword: yup.string()
        .oneOf([yup.ref('password'), null], 'رمزها باید یکسان باشند')
        .required('تکرار رمز عبور الزامی است'),
}).required();

function Contact() {
    const {register, handleSubmit,formState: {errors},} = useForm({
        resolver: yupResolver(schema),
    });

 /*   const { register, handleSubmit,  formState: {errors}, } = useForm({
        resolver: yupResolver(validationSchema),
    });
*/

    return (
        <div className='container'>
            <p>Contact</p>
            <div className="row">
                <div className="col-6">
                    <form onSubmit={handleSubmit((d) => console.log(d))}>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" placeholder="نام" {...register('name')}/>
                            {errors.name && ( <p style={{color: "red", fontSize: "14px"}}>  {errors.name.message}  </p> )}
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control"
                                   placeholder="نام خانوادگی" {...register('family')}/>
                            {errors.family && ( <p style={{color: "red", fontSize: "14px"}}>  {errors.family.message}  </p> )}
                        </div>
                        <div className="form-group mb-3">
                            <input type="number" className="form-control" placeholder="سن" {...register('age')}/>
                            {errors.age && ( <p style={{color: "red", fontSize: "14px"}}>  {errors.age.message}  </p> )}
                        </div>
                        <div className="form-group mb-3">
                            <input type="text" className="form-control" placeholder="ایمیل"
                                   autoComplete="username" {...register('email')}/>
                            {errors.email && ( <p style={{color: "red", fontSize: "14px"}}>  {errors.email.message}  </p> )}
                        </div>
                        <div className="form-group mb-3">
                            <input type="password" className="form-control" placeholder="رمز عبور"
                                   autoComplete="current-password" {...register('password')}/>
                            {errors.password && ( <p style={{color: "red", fontSize: "14px"}}>  {errors.password.message}  </p> )}
                        </div>
                        <div className="form-group mb-3">
                            <input type="password" className="form-control" placeholder="تائید رمز"
                                   autoComplete="current-password" {...register('confirmPassword')}/>
                            {errors.confirmPassword && ( <p style={{color: "red", fontSize: "14px"}}>  {errors.confirmPassword.message}  </p> )}
                        </div>
                        <button type="submit" className="btn btn-success mx-2 px-4 py-2">ثبت</button>
                    </form>
                </div>
            </div>

        </div>
    )
}

export default Contact
